import { Grid, Typography, Divider } from '@material-ui/core'
import React, { useState } from 'react'
import { Label, LinkS } from '../../../../../../components/UiElements/UiElements'
import CompleteOrderImage from '../../../../../../assets/img/stepper/complete_order.png';
import { formateMdnNumber } from '../../../../../../../src/components/Common/Extensions';

import useStyles from "./styles";
function OrderCompleted({ msisdn, fromCarrier, data, ...props }) {
    const classes = useStyles();
    const [state, setState] = useState({});
    const handleChange = (e) => {
        const { name, value } = e.target;

        setState((prevState) => ({
            ...prevState,
            [name]: value,

        }));
    }
    return (
        <Grid container justifyContent='center'>
            <Grid item lg={12}>
                <div className={classes.subContainer}>
                    <img src={CompleteOrderImage} alt="order" />
                    <Typography className={classes.text}>
                        Your Port-In request for <b><LinkS className={classes.linkItem}>{formateMdnNumber(msisdn)}</LinkS></b> from <b>{fromCarrier == 'Other' ? fromCarrier.otherCarrier : fromCarrier}</b> to FIGGERS on <b>{data.wirelessPlanType}</b> has been completed.
                    </Typography>
                </div>
            </Grid>
        </Grid>
    )
}

export default OrderCompleted